import React from 'react';
import App from 'next/app';
import _get from 'lodash/get';
import sentry from '@utils/sentry';
import Session from '@libs/session';
import { InitProvider, InitContext } from '@contexts/Init';
import { init as initApm } from '@elastic/apm-rum';
import config from '@root/config';

const isDevelopment = process.env.NODE_ENV === 'development';
const { captureException } = sentry();

if (!isDevelopment) {
    initApm({
        serviceName: config.TRACKING_SERVICE_NAME,
        serverUrl: config.TRACKING_APM_SERVER_URL,
        environment: config.TRACKING_ENVIRONMENT,
    });
};

class OkaApp extends App {
    static async getInitialProps({ Component, ctx }) {
        const {
            query
        } = ctx;
        let pageProps = {};

        let facilities = _get(query, 'facilities') || [];
        const headerHeight = _get(query, 'header', 0) || 0;
        if (typeof facilities !== 'object') {
            facilities = [facilities];
        }
        let facility = facilities[0] || false;

        if (+query.facility > 0) {
            facility = query.facility;
        }

        if (Component.getInitialProps) {
            pageProps = await Component.getInitialProps(ctx);
        }

        
        return {
            pageProps: {
                query: {
                    ...query,
                    facilities,
                    facility,
                    headerHeight
                },
                ...query,
                ...pageProps,
                facilities,
                facility,
                headerHeight
            }
        }
    }

    componentDidMount() {
        const { pageProps: { query } } = this.props;

        const oldSource = Session.get('source');
        const newSource = _get(query, 'source');
        if (newSource && (newSource != oldSource)) {
            Session.set('source', newSource);
        }
    }

    componentDidCatch(error, errorInfo) {
        captureException(error, { errorInfo });
    }

    render() {
        const { Component } = this.props;
        return (
            <>
                <InitProvider {...this.props.pageProps}>
                    <InitContext.Consumer>
                        {init => {
                            const propsData = {
                                ...this.props.pageProps,
                                ...init.settings,
                                query: {
                                    ...this.props.pageProps.query,
                                    ...init.settings
                                }
                            };
                            return (
                                <Component {...propsData} init={init} />
                            )
                        }}
                    </InitContext.Consumer>
                </InitProvider>
            </>
        )
    }
}

export default OkaApp;